import PageTitle from "../components/common/PageTitle";
import { TabPanel, TabView } from "primereact/tabview";
import CoursePromoDialogsTab from "../components/manage_promo_dialogs/course/CoursePromoDialogsTab";
import ExamsPromoDialogsTab from "../components/manage_promo_dialogs/exam/ExamsPromoDialogsTab";
import DashboardPromoDialogsTab from "../components/manage_promo_dialogs/dashboard/DashboardPromoDialogsTab";
import SelfTestPromoDialogsTab from "../components/manage_promo_dialogs/self_test/SelfTestPromoDialogsTab";

export default function ManagePromoDialogs() {
    return (
        <div className="flex flex-column h-full overflow-hidden">
            <PageTitle title="Promo Dialogs" />
            <TabView className="flex-1 overflow-y-auto" panelContainerClassName="p-0">
                <TabPanel header="Courses">
                    <CoursePromoDialogsTab />
                </TabPanel>
                <TabPanel header="Exams">
                    <ExamsPromoDialogsTab />
                </TabPanel>
                <TabPanel header="Dashboard">
                    <DashboardPromoDialogsTab />
                </TabPanel>
                <TabPanel header="Self Test">
                    <SelfTestPromoDialogsTab />
                </TabPanel>
            </TabView>
        </div>
    );
}
